// imports
import { fetchDirectPlansAndroidApi, checkoutDirectPlanAndroidApi } from 'api/directAndroidPlans';
import { notify } from 'redux/actions/notice';
// ------------------------------------
// Constants
// ------------------------------------
export const FETCH_DIRECT_PLANS_ANDROID_START = 'FETCH_DIRECT_PLANS_ANDROID_START';
export const FETCH_DIRECT_PLANS_ANDROID_END = 'FETCH_DIRECT_PLANS_ANDROID_END';
export const SELECT_DIRECT_PLANS_ANDROID = 'SELECT_DIRECT_PLANS_ANDROID';
export const CHECKOUT_DIRECT_PLANS_ANDROID_START = 'CHECKOUT_DIRECT_PLANS_ANDROID_START';
export const CHECKOUT_DIRECT_PLANS_ANDROID_END = 'CHECKOUT_DIRECT_PLANS_ANDROID_END';
export const DIRECT_PLANS_ANDROID_ERROR = 'DIRECT_PLANS_ANDROID_ERROR';
// ------------------------------------
// Actions
// ------------------------------------

export function fetchDirectPlansAndroidStart() {
  return ({ type: FETCH_DIRECT_PLANS_ANDROID_START });
}

export function fetchDirectPlansAndroidEnd(payload) {
  return ({ type: FETCH_DIRECT_PLANS_ANDROID_END, payload });
}

export function checkoutDirectPlanAndroidStart() {
  return ({ type: CHECKOUT_DIRECT_PLANS_ANDROID_START });
}

export function checkoutDirectPlanAndroidEnd() {
  return ({ type: CHECKOUT_DIRECT_PLANS_ANDROID_END });
}

export function raiseErrorDirectPlansAndroid() {
  return ({ type: DIRECT_PLANS_ANDROID_ERROR });
}

export function selectDirectPlanAndroid(payload) {
  return ({ type: SELECT_DIRECT_PLANS_ANDROID, payload });
}

export function checkoutDirectPlanAndroid(plan, done = () => { }) {
  return (dispatch, getState) => {
    const { i18n: { info: { locale } } } = getState();
    dispatch(selectDirectPlanAndroid(plan));
    dispatch(checkoutDirectPlanAndroidStart());
    checkoutDirectPlanAndroidApi(plan.planID, locale)
      .then((res = {}) => {
        const resBody = res.body;
        done(null, resBody);
        dispatch(checkoutDirectPlanAndroidEnd());
      })
      .catch((error) => {
        dispatch(notify({ error }));
        dispatch(checkoutDirectPlanAndroidEnd());
        done(error);
      });
  };
}
export function loadDirectPlansAndroid(options = {}) {
  return (dispatch, getState) => {
    const { auth: { info } } = getState();
    dispatch(fetchDirectPlansAndroidStart());
    // api call
    // first check options country then user's profile country if exist
    fetchDirectPlansAndroidApi((
      options.countryCode ||
      (info &&
      info.profile &&
      info.profile.countryCode)
    ))
      .then((res) => {
        dispatch(fetchDirectPlansAndroidEnd(res));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/directPlansAndroid.js